import { createApp } from 'vue'
import ApplicationRoot from './ApplicationRoot.vue'
import { internationalization } from './i18n/index.ts'
import { vuetify } from './plugins/vuetify.ts'
import { applicationRouter } from './router.ts'
import { installApplicationResetHelper } from './developmentTools/applicationReset.ts'
import { installPwaResetHelper } from './serviceWorker/pwaReset.ts'
import { registerApplicationServiceWorker } from './serviceWorker/registerServiceWorker.ts'

createApp(ApplicationRoot)
  .use(internationalization)
  .use(vuetify)
  .use(applicationRouter)
  .mount('#application-root')

// The service worker is emitted by the build, so under the development server the file does
// not exist and the request falls through to `index.html`. The browser then refuses it for
// its MIME type and writes an error nobody can catch, which is noise that hides real ones.
// This asks "am I being served by the dev server", which is exactly what this flag answers
// and what the built bundle always answers with `false` — it never decides what kind of
// deployment this is, which is what `/api/auth/status` is for.
if (!import.meta.env.DEV) {
  void registerApplicationServiceWorker()
}

// A stale service worker is a development trap, so the way out lives in the console, next
// to the larger hammer that forgets everything this origin kept. Never in production, where
// between them they would discard somebody's signed-in accounts and their offline copy.
if (import.meta.env.DEV) {
  installPwaResetHelper()
  installApplicationResetHelper()
}
